import { Tooltip, Table, Tag, Popconfirm, message, Spin } from "antd";
import { dealFileSize } from "@/utils/dealFileSize";
import { DeleteOutlined } from "@ant-design/icons";
import downImg from "@/assets/images/discover/down.png";
import intl from "react-intl-universal";
import styles from "./fileModal.module.scss";
import classNames from "classnames";
import { deleteFile, getResourceFileDownloadUrl } from "@/apis/discover";
import { useState } from "react";
const FileModal = ({ treeData, resourceUuid, deleteFileById }) => {
  const [loading, setLoading] = useState(false)
  const [deletingFileUuid, setDeletingFileUuid] = useState("");
  const [deletedFileUuids, setDeletedFileUuids] = useState([]);
  const deleteFileData = (id) => {
    if (!id || deletingFileUuid) {
      return;
    }

    setDeletingFileUuid(id);
    deleteFile({
      resourceUuid,
      fileUuid: id,
    }).then(() => {
      message.success("删除成功！");
      setDeletedFileUuids((prev) => (prev.includes(id) ? prev : [...prev, id]));
      deleteFileById(id);
    }).catch((err) => {
      const errText = String(err?.msg || err?.message || err || "");
      if (
        errText.includes("不存在") ||
        errText.toLowerCase().includes("not exist") ||
        errText.toLowerCase().includes("not found")
      ) {
        setDeletedFileUuids((prev) => (prev.includes(id) ? prev : [...prev, id]));
        deleteFileById(id);
      }
    }).finally(() => {
      setDeletingFileUuid("");
    });
  };
  const downLoadFile = async (id) => {
    setLoading(true);
    try {
      const url = await getResourceFileDownloadUrl(resourceUuid, id, { management: true });
      window.location.assign(url);
    } catch (error) {
      // Errors are displayed by the shared request handler.
    } finally {
      setLoading(false);
    }
  };
  const visibleTreeData = treeData.filter(
    (item) => !deletedFileUuids.includes(item.fileUuid)
  );
  const columns = [
    {
      title: intl.get("Share.File Name"),
      key: "fileName",
      dataIndex: "fileName",
      width: 500,
      render: (_, record) => <span>{record.fileRelativePath?record.fileRelativePath:record.fileName}</span>,
    },
    {
      title: intl.get("Share.Format"),
      key: "suffix",
      dataIndex: "suffix",
      width: 100,
      render: (_, record) => <Tag color="gold">{record.suffix}</Tag>,
    },
    {
      title: intl.get("Share.File Size"),
      key: "size",
      dataIndex: "size",
      width: 100,
      render: (_, record) => <span>{dealFileSize(record.size)}</span>,
    },
    {
      title: intl.get("Operation"),
      key: "operate",
      width: 100,
      render: (text, record) => (
        <div className={classNames(styles.downBox, "flex_box", "align_center")}>
          <Tooltip title={intl.get("Share.Download the file")}>
            <img
              src={downImg}
              onClick={() => record.fileUuid && downLoadFile(record.fileUuid)}
            />
          </Tooltip>
          <Tooltip title={intl.get("Delete the file")}>
            <Popconfirm
              title={intl.get("Delete the file")}
              description={intl.get("Whether to continue the execution")}
              onConfirm={() => deleteFileData(record.fileUuid)}
              okText={intl.get("Yes")}
              cancelText={intl.get("No")}
              disabled={!record.fileUuid || deletingFileUuid === record.fileUuid}
            >
              <DeleteOutlined
                style={{
                  color: deletingFileUuid === record.fileUuid ? "#999" : "#d62293",
                  fontSize: "18px",
                }}
              />
            </Popconfirm>
          </Tooltip>
        </div>
      ),
    },
  ];
  return (
    <Spin spinning={loading} tip={intl.get("File downloading, please wait patiently")}>
        <Table
          rowKey={(record) => record.fileUuid}
          draggable
          size="small"
          scroll={{ y: "550px" }}
          pagination={false}
          dataSource={visibleTreeData}
          columns={columns}
        />
    </Spin>
  );
};
export default FileModal;
